import FieldClass from '../models/admin/iField';
import moment from 'moment';
import IntlMessages from './IntlMessages';
import * as htmlToImage from 'html-to-image';
import { DateFilterEnum } from './enums';

class GeneralsHelper {
  // #region WE RESIZE THE CANVAS DOWN WHEN SAVING /*  */ON RETINA DEVICES OTHERWISE THE IMAGE
  static getResizedCanvas(img, maxWidth, maxHeight, degrees) {
    const imgWidth = img.width;
    const imgHeight = img.height;

    let ratio = 1;
    let ratio1 = 1;
    let ratio2 = 1;
    ratio1 = maxWidth / imgWidth;
    ratio2 = maxHeight / imgHeight;

    // USE THE SMALLEST RATIO THAT THE IMAGE BEST FIT INTO THE MAXWIDTH X MAXHEIGHT BOX.
    if (ratio1 < ratio2) {
      ratio = ratio1;
    } else {
      ratio = ratio2;
    }
    const canvas = document.createElement('canvas');
    const canvasContext = canvas.getContext('2d');
    const canvasCopy = document.createElement('canvas');
    const copyContext = canvasCopy.getContext('2d');
    const canvasCopy2 = document.createElement('canvas');
    const copyContext2 = canvasCopy2.getContext('2d');
    canvasCopy.width = imgWidth;
    canvasCopy.height = imgHeight;
    copyContext.drawImage(img, 0, 0);

    // INIT
    canvasCopy2.width = imgWidth;
    canvasCopy2.height = imgHeight;
    copyContext2.drawImage(
      canvasCopy,
      0,
      0,
      canvasCopy.width,
      canvasCopy.height,
      0,
      0,
      canvasCopy2.width,
      canvasCopy2.height,
    );

    const rounds = 1;
    const roundRatio = ratio * rounds;
    for (let i = 1; i <= rounds; i++) {
      // TMP
      canvasCopy.width = (imgWidth * roundRatio) / i;
      canvasCopy.height = (imgHeight * roundRatio) / i;

      copyContext.drawImage(
        canvasCopy2,
        0,
        0,
        canvasCopy2.width,
        canvasCopy2.height,
        0,
        0,
        canvasCopy.width,
        canvasCopy.height,
      );

      // COPY BACK
      canvasCopy2.width = (imgWidth * roundRatio) / i;
      canvasCopy2.height = (imgHeight * roundRatio) / i;
      copyContext2.drawImage(
        canvasCopy,
        0,
        0,
        canvasCopy.width,
        canvasCopy.height,
        0,
        0,
        canvasCopy2.width,
        canvasCopy2.height,
      );
    } // END FOR

    canvas.width = (imgWidth * roundRatio) / rounds;
    canvas.height = (imgHeight * roundRatio) / rounds;
    canvasContext.drawImage(canvasCopy2, 0, 0, canvasCopy2.width, canvasCopy2.height, 0, 0, canvas.width, canvas.height);

    if (degrees === 90 || degrees === 270) {
      canvas.width = canvasCopy2.height;
      canvas.height = canvasCopy2.width;
    } else {
      canvas.width = canvasCopy2.width;
      canvas.height = canvasCopy2.height;
    }

    canvasContext.clearRect(0, 0, canvas.width, canvas.height);
    if (degrees === 90 || degrees === 270) {
      canvasContext.translate(canvasCopy2.height / 2, canvasCopy2.width / 2);
    } else {
      canvasContext.translate(canvasCopy2.width / 2, canvasCopy2.height / 2);
    }
    canvasContext.rotate((degrees * Math.PI) / 180);
    canvasContext.drawImage(canvasCopy2, -canvasCopy2.width / 2, -canvasCopy2.height / 2);
    return canvas;
  }
  // #endregion

  static getStatusObject(status) {
    const statusArray = {
      APPROVED: {
        name: <IntlMessages id={`status.${status?.toLowerCase()}`} />,
        color: '#21823E',
        classBadge: 'success',
      },
      ACTIVE: {
        name: <IntlMessages id={`generals.status-${status?.toLowerCase()}`} />,
        color: '#21823E',
        classBadge: 'success',
      },
      EXECUTED: {
        name: <IntlMessages id={`generals.status-${status?.toLowerCase()}`} />,
        color: '#21823E',
        classBadge: 'success',
      },
      PROCESS: {
        name: <IntlMessages id={`generals.status-${status?.toLowerCase()}`} />,
        color: '#377cfd',
        classBadge: 'primary',
      },
      DENIED: {
        name: <IntlMessages id={`generals.status-${status?.toLowerCase()}`} />,
        color: '#FF8C00',
        classBadge: 'danger',
      },
      INACTIVE: {
        name: <IntlMessages id={`generals.status-${status?.toLowerCase()}`} />,
        color: '#FF8C00',
        classBadge: 'danger',
      },
      CREATED: {
        name: <IntlMessages id={`generals.status-${status?.toLowerCase()}`} />,
        color: '#FF8C00',
        classBadge: 'warning',
      },
      EXCEPTION: {
        name: <IntlMessages id={`generals.status-${status?.toLowerCase()}`} />,
        color: '#FF8C00',
        classBadge: 'warning',
      },
      INACTIVE_IN_PROCESS: {
        name: <IntlMessages id={`generals.status-${status?.toLowerCase()}`} />,
        color: '#FF8C00',
        classBadge: 'danger',
      },
      DELETED: {
        name: <IntlMessages id={`generals.status-${status?.toLowerCase()}`} />,
        color: '#FF2A00',
        classBadge: 'danger',
      },
      VOIDED: {
        name: <IntlMessages id={`generals.status-${status?.toLowerCase()}`} />,
        color: '#FF2A00',
        classBadge: 'danger',
      },
      ERROR: {
        name: <IntlMessages id={`generals.status-${status?.toLowerCase()}`} />,
        color: '#FF2A00',
        classBadge: 'danger',
      },
      PENDING: {
        name: <IntlMessages id={`status.${status?.toLowerCase()}`} />,
        color: '#FF8C00',
        classBadge: 'warning',
      },
      EXECUTE: {
        name: <IntlMessages id={`generals.status-${status?.toLowerCase()}`} />,
        color: '#21823E',
        classBadge: 'success',
      },
      PAID: {
        name: <IntlMessages id={`generals.status-${status?.toLowerCase()}`} />,
        color: '#21823E',
        classBadge: 'success',
      },
      REASSIGN_DATE: {
        name: <IntlMessages id={`generals.status-${status?.toLowerCase()}`} />,
        color: '#21823E',
        classBadge: 'success',
      },
      PENDING_DEBIT: {
        name: <IntlMessages id={`generals.status.${status?.toLowerCase()}`} />,
        color: '#FF8C00',
        classBadge: 'warning',
      },
    };
    return statusArray[status];
  }

  static isset(consulta) {
    // LLAMAR: GeneralsHelper.isset(() => objeto) OR: GeneralsHelper.isset(() => objeto.campo)
    try {
      return typeof consulta() !== 'undefined';
    } catch (e) {
      return false;
    }
  }

  static completeNameReduced(user, initCapitalLetters, inverted = false) {
    let completeName = '';

    if (user != null) {
      const nameSeparated = user.name != null ? user.name.split(' ')[0] : '';
      const apellidosSeparados = user.lastname != null ? user.lastname : '';

      completeName = `${apellidosSeparados} ${nameSeparated}`;
      if (inverted) {
        completeName = `${nameSeparated} ${apellidosSeparados}`;
      }

      if (initCapitalLetters) {
        completeName = GeneralsHelper.UppercaseWord(completeName);
      }
    }

    return completeName;
  }

  static UppercaseWord(str) {
    const pieces = str.toLowerCase().split(' ');
    for (let i = 0; i < pieces.length; i++) {
      const j = pieces[i].charAt(0).toUpperCase();
      pieces[i] = j + pieces[i].substr(1);
    }
    return pieces.join(' ');
  }

  static getContrastTextByBackgroundColor(hexadecimal) {
    if (hexadecimal === '' || !hexadecimal) {
      hexadecimal = '#ffffff';
    }
    const arrayColorRgb = this.getRGBFromHexadecimal(hexadecimal.replace('#', ''));

    const o = Math.round(
      (parseInt(arrayColorRgb[0]) * 299 + parseInt(arrayColorRgb[1]) * 587 + parseInt(arrayColorRgb[2]) * 114) / 1000,
    );
    const fore = o > 125 ? '#000' : '#fff';
    return fore;
  }

  static getDifferenceDate(currentDate, endDateConnection, type) {
    const differenceDate = moment.duration(currentDate.diff(endDateConnection));
    switch (type) {
      case 'days':
        return parseInt(differenceDate.asDays());
      case 'hours':
        return parseInt(differenceDate.asHours());
      case 'months':
        return parseInt(differenceDate.asMonths());
      case 'years':
        return parseInt(differenceDate.asYears());
      case 'seconds':
        return parseInt(differenceDate.asSeconds());
      case 'weeks':
        return parseInt(differenceDate.asWeeks());
      default:
        return parseInt(differenceDate.asMinutes());
    }
  }

  static getTextDifferenceDate(currentDate, endDate) {
    const differenceDates = moment.duration(currentDate.diff(endDate));
    const year = differenceDates.get('years');
    const months = differenceDates.get('months');
    const days = differenceDates.get('days');
    const hours = differenceDates.get('hours');
    const minutes = differenceDates.get('minutes');

    let textoTiempo = `${year > 0 ? `${year} año${year > 1 ? 's' : ''}` : ''}${
      months > 0 ? ` ${months} mes${months > 1 ? 'es' : ''}` : ''
    }${days > 0 ? ` ${days} día${days > 1 ? 's' : ''}` : ''}${hours > 0 ? ` ${hours} hora${hours > 1 ? 's' : ''}` : ''}${
      minutes > 0 ? ` ${minutes} minuto${minutes > 1 ? 's' : ''}` : ''
    }`;

    return textoTiempo.trim();
  }

  static getLastConnection(currentDate, endDateConnection) {
    const differenceDate = moment.duration(currentDate.diff(endDateConnection));
    const years = differenceDate.get('years');
    const months = differenceDate.get('months');
    const days = differenceDate.get('days');
    const hours = differenceDate.get('hours');
    const minutes = differenceDate.get('minutes');
    const seconds = differenceDate.get('seconds');
    if (+years > 0) {
      return `${years} año${years > 1 ? 's' : ''}`;
    }
    if (+months > 0) {
      return `${months} mese${months > 1 ? 's' : ''}`;
    }
    if (+days > 0) {
      return `${days} día${days > 1 ? 's' : ''}`;
    }
    if (+hours > 0) {
      return `${hours} hora${hours > 1 ? 's' : ''}`;
    }
    if (+minutes > 0) {
      return `${minutes} minuto${minutes > 1 ? 's' : ''}`;
    }
    if (+seconds > 0) {
      return `${seconds} segundo${seconds > 1 ? 's' : ''}`;
    }
    return '';
  }

  static convertFormat12Hours(time) {
    const arrayTime = time.split(':');
    let ampm = 'AM';
    if (arrayTime[0] >= 12) {
      ampm = 'PM';
    }
    if (arrayTime[0] > 12) {
      arrayTime[0] -= 12;
    }
    time = `${arrayTime[0]}:${arrayTime[1]}:${arrayTime[2]} ${ampm}`;
    return time;
  }

  static getRGBFromHexadecimal(hexadecimal) {
    const bigint = parseInt(hexadecimal, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return [r, g, b];
  }

  static isInt(n) {
    return Number(n) === n && n % 1 === 0;
  }

  static isFloat(n) {
    return Number(n) === n && n % 1 !== 0;
  }

  static getValue(objeto, arrayPalabras) {
    // Función recursiva
    const primeraPalabra = arrayPalabras[0]; // Obtener la primera palabra del arrayPalabras
    arrayPalabras.splice(0, 1); // Eliminación de la primera palabra del array
    if (GeneralsHelper.isset(() => objeto[primeraPalabra])) {
      if (arrayPalabras.length === 0) {
        // Si solo existia una palabra, return el valor del objeto[primeraPalabra]
        return objeto[primeraPalabra];
      }
      // Sino invocar a la misma función
      return this.getValue(objeto[primeraPalabra], arrayPalabras);
    }
    return null;
  }

  static getCenterOfCoordinateList(coordinates) {
    if (coordinates?.length === 1) {
      return coordinates[0];
    }

    let x = 0;
    let y = 0;
    let z = 0;

    coordinates.forEach((coordinate) => {
      const latitude = (coordinate?.lat * Math.PI) / 180;
      const longitude = (coordinate?.lng * Math.PI) / 180;

      x += Math.cos(latitude) * Math.cos(longitude);
      y += Math.cos(latitude) * Math.sin(longitude);
      z += Math.sin(latitude);
    });

    const total = coordinates?.length;

    x /= total;
    y /= total;
    z /= total;

    const centerLongitude = Math.atan2(y, x);
    const centerSquareRoot = Math.sqrt(x * x + y * y);
    const centerLatitude = Math.atan2(z, centerSquareRoot);

    return { latitude: (centerLatitude * 180) / Math.PI, longitude: (centerLongitude * 180) / Math.PI };
  }

  static getRandomColor() {
    // var letters = '0123456789ABCDEF';
    // var color = '#';
    // for (var i = 0; i < 6; i++) {
    //   color += letters[Math.floor(Math.random() * 16)];
    // }
    // return color;
    const color = `hsl(${Math.random() * 360}, 100%, 75%)`;
    return color;
  }

  static fieldsProcess(fiels) {
    const fields = [];
    if (fiels?.TableColumns?.length > 0) {
      fiels.TableColumns.forEach((fiel) => {
        fields.push(new FieldClass(fiel?.order, fiel?.title, fiel?.field_name, true, fiel.aling, 'tableCellSecond'));
      });
    }
    return fields;
  }

  static IsJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
  static getBgColorStatus(status) {
    const color = {
      ACTIVE: '#21823E',
      INACTIVE: '#FF8C00',
      CONFIRMED: '#21823E',
      RESOLVED: '#21823E',
      PENDING: '#ff8c00cf',
      EXCEPTION: '#FF2A00',
      TIED: '#2766EC',
      NO_NEGOTIATIONS: '#2766EC',
      DISCARD: '#FF2A00',
      CREATE_NEW: '#f50057',
      ERROR: '#f50057',
      CREATE: '#3399FF',
      REVISION: '#3f51b5ad',
      DISCARDED: '#FF2A00',
      ENTRY: '#3399FF',
      ASSIGNED: '#21823E',
      NOT_AUTHENTICATED: '#ff8c00cf',
      SATISFACTORY: '#21823E',
      NOT_FOUND: '#FF2A00',
      REASSIGN_DATE: '#ff8c00cf',
    };
    return color[status];
  }

  static capitalizeFirstLetter(strValue) {
    let strValueLowerCase = strValue.toLowerCase();
    return strValue.charAt(0).toUpperCase() + strValueLowerCase.slice(1);
  }

  static onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  static encodeBase64 = (data) => {
    return data && data !== '' ? btoa(unescape(encodeURIComponent(data))) : '';
  };

  static decodeBase64 = (data) => {
    return data && data !== '' ? decodeURIComponent(escape(atob(data))) : '';
  };

  static highchartsExport(highcharts, messages) {
    highcharts.setOptions({
      lang: {
        downloadPNG: messages['dahsboards.downloadPNG'],
        downloadJPEG: messages['dahsboards.downloadJPEG'],
        downloadPDF: messages['dahsboards.downloadPDF'],
        downloadSVG: messages['dahsboards.downloadSVG'],
        viewFullscreen: messages['dahsboards.viewFullscreen'],
        exitFullscreen: messages['dahsboards.exitFullscreen'],
        printChart: messages['dahsboards.printChart'],
      },

      exporting: {
        buttons: {
          contextButton: {
            menuItems: ['viewFullscreen', 'downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG'],
          },
        },
      },
    });
  }

  static getCharacterHelpMessage(characters) {
    switch (characters) {
      case 'ONLY_LETTERS':
        return (
          <span className="text-danger text-extra-small">
            <IntlMessages id={`generals.help-message.${characters.toUpperCase()}`} />
          </span>
        );
      case 'DECIMAL':
        return (
          <span className="text-danger text-extra-small">
            <IntlMessages id={`generals.help-message.${characters.toUpperCase()}`} />
          </span>
        );
      case 'INT':
        return (
          <span className="text-danger text-extra-small">
            <IntlMessages id={`generals.help-message.${characters.toUpperCase()}`} />
          </span>
        );
      case 'PERCENTAGE':
        return (
          <span className="text-danger text-extra-small">
            <IntlMessages id={`generals.help-message.${characters.toUpperCase()}`} />
          </span>
        );
      case 'LETTERS_AND_NUMBERS':
        return (
          <span className="text-danger text-extra-small">
            <IntlMessages id={`generals.help-message.${characters.toUpperCase()}`} />
          </span>
        );
      default:
        return '';
    }
  }

  static getLineCount(element) {
    const spanHeight = element.offsetHeight;

    const tempElement = document.createElement('span');
    tempElement.innerText = 'A';
    tempElement.style.font = window.getComputedStyle(element).font;
    document.body.appendChild(tempElement);
    const lineHeight = tempElement.offsetHeight;
    document.body.removeChild(tempElement);

    const lineCount = Math.round(spanHeight / lineHeight);
    return lineCount;
  }

  static getMaxValueIntegers(array) {
    if (array.length === 0) {
      return 0;
    }

    let numeroMayor = array[0];

    for (let i = 1; i < array.length; i++) {
      if (array[i] > numeroMayor) {
        numeroMayor = array[i];
      }
    }

    return numeroMayor;
  }

  static getImageFromHtml = async (element, format) => {
    const contenido = element ? element : '<div>error</div>';

    let dataUrl = '';
    switch (format) {
      case 'jpg':
        dataUrl = await htmlToImage.toJpeg(contenido);
        break;
      case 'png':
        dataUrl = await htmlToImage.toPng(contenido);
        break;
      case 'svg':
        dataUrl = await htmlToImage.toSvg(contenido);
        break;
      default:
        break;
    }
    const link = document.createElement('a');
    link.download = `image.${format}`;
    link.href = dataUrl;
    link.click();
  };

  static formatBytes(value, decimals = 2) {
    if (!+value) return '0 Bytes';
    const c = 0 > decimals ? 0 : decimals,
      d = Math.floor(Math.log(value) / Math.log(1024));
    return `${parseFloat((value / Math.pow(1024, d)).toFixed(c))} ${
      ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'][d]
    }`;
  }

  static MBtoBytes(megabytes) {
    const bytesInMB = 1024 * 1024;
    const bytes = megabytes * bytesInMB;
    return bytes;
  }

  static removeNulls(objectData) {
    try {
      let newObject = { ...objectData };
      for (let keyData in newObject) {
        if (newObject.hasOwnProperty(keyData) && newObject[keyData] === null) {
          delete newObject[keyData];
        }
      }
      return newObject;
    } catch (Exception) {
      return objectData;
    }
  }
  static getDateArray(start, end, days) {
    // Parsear las fechas
    const startDate = new Date(start);
    const endDate = new Date(end);

    // Verificar que las fechas son válidas
    if (isNaN(startDate) || isNaN(endDate) || startDate > endDate) {
      throw new Error('Fechas no válidas');
    }
    const arrayDates = [];
    let currentDate = new Date(startDate);
    while (currentDate <= endDate) {
      if (!days?.includes(currentDate.getDay())) {
        arrayDates.push(currentDate.toISOString().split('T')[0]);
      }
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return arrayDates;
  }

  static formatDollar(number) {
    let dollarUSLocale = Intl.NumberFormat('en-US');
    return `$${dollarUSLocale.format(number ?? 0)}`;
  }
  static truncatedText(text, maxLength) {
    return text && text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  }
  static generateRandomCode(codeLength) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let code = '';

    for (let i = 0; i < codeLength; i++) {
      const indice = Math.floor(Math.random() * chars.length);
      code += chars.charAt(indice);
    }

    return code;
  }
  static getDateByType = (dateOption) => {
    switch (dateOption) {
      case DateFilterEnum.TODAY:
        return {
          type: { label: dateOption, value: dateOption },
          startDate: moment().startOf('day'),
          endDate: moment().endOf('day'),
        };
      case DateFilterEnum.YESTERDAY:
        return {
          type: { label: dateOption, value: dateOption },
          startDate: moment().subtract(1, 'days').startOf('day'),
          endDate: moment().subtract(1, 'days').endOf('day'),
        };
      case DateFilterEnum.CURRENT_WEEK:
        return {
          type: { label: dateOption, value: dateOption },
          startDate: moment().startOf('week'),
          endDate: moment().endOf('week'),
        };
      case DateFilterEnum.LAST_WEEK:
        return {
          type: { label: dateOption, value: dateOption },
          startDate: moment().subtract(1, 'week').startOf('week'),
          endDate: moment().subtract(1, 'week').endOf('week'),
        };
      case DateFilterEnum.CURRENT_YEAR:
        return {
          type: { label: dateOption, value: dateOption },
          startDate: moment().startOf('year'),
          endDate: moment().endOf('year'),
        };
      case DateFilterEnum.CURRENT_YEAR_TODAY:
        return {
          type: { label: dateOption, value: dateOption },
          startDate: moment().startOf('year'),
          endDate: moment(),
        };
      case DateFilterEnum.CURRENT_YEAR_YESTERDAY:
        return {
          type: { label: dateOption, value: dateOption },
          startDate: moment().date() > 1 ? moment().startOf('year') : moment().subtract(1, 'days').startOf('year'),
          endDate: moment().date() > 1 ? moment().subtract(1, 'days') : moment().subtract(1, 'months').endOf('month'),
        };
      case DateFilterEnum.LAST_YEAR:
        return {
          type: { label: dateOption, value: dateOption },
          startDate: moment().subtract(1, 'years').startOf('year'),
          endDate: moment().subtract(1, 'years').endOf('year'),
        };
      case DateFilterEnum.CURRENT_MONTH_TODAY:
        return {
          type: { label: dateOption, value: dateOption },
          startDate: moment().startOf('month'),
          endDate: moment(),
        };
      case DateFilterEnum.CURRENT_MONTH:
        return {
          type: { label: dateOption, value: dateOption },
          startDate: moment().startOf('month'),
          endDate: moment().endOf('month'),
        };
      case DateFilterEnum.CURRENT_MONTH_YESTERDAY:
        return {
          type: { label: dateOption, value: dateOption },
          startDate: moment().date() > 1 ? moment().startOf('month') : moment().subtract(1, 'months').startOf('month'),
          endDate: moment().date() > 1 ? moment().subtract(1, 'days') : moment().subtract(1, 'months').endOf('month'),
        };
      case DateFilterEnum.LAST_MONTH:
        return {
          type: { label: dateOption, value: dateOption },
          startDate: moment().subtract(1, 'months').startOf('month'),
          endDate: moment().subtract(1, 'months').endOf('month'),
        };
      default:
        break;
    }
  };
  static formatMinutesToTime = (minutes) => {
    let hours = Math.floor(minutes / 60);
    let mins = minutes % 60;
    return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}:00`;
  };
  static formatSecondsToTime = (seconds) => {
    let hours = Math.floor(seconds / 3600); // 3600 segundos en una hora
    let mins = Math.floor((seconds % 3600) / 60); // El resto dividido entre 60 para obtener los minutos
    let secs = seconds % 60; // El resto son los segundos
    return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };
  static getReference = (usersMatchesReference) => {
    if (usersMatchesReference) {
      const arrayReferences = [
        usersMatchesReference.province,
        usersMatchesReference.canton,
        usersMatchesReference.city,
        usersMatchesReference.parish,
        usersMatchesReference.sector,
      ];
      return arrayReferences.filter((reference) => reference && reference !== '').join(' - ') || '';
    }
    return '';
  };
  static formatTimeToString(value, type) {
    if (type === 'seconds') {
      const hours = Math.floor(Number(value) / 3600);
      const minutes = Math.floor((Number(value) % 3600) / 60);
      const seconds = Number(value) % 60;
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    } else if (type === 'minutes') {
      const hours = Math.floor(Number(value) / 60);
      const minutes = Number(value) % 60;
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    } else {
      return value;
    }
  }
}

export default GeneralsHelper;
